import { OrderingFacade } from 'pos/facades';

// Bloquea el ticket mientras se realiza una operación de cierre sobre el ticket para evitar que pueda ser modificado desde
// otro punto de venta mientras se realiza el pago
export default async function blockTicketWhileClosing<K>(ticketId: number, closingAction: () => Promise<K>): Promise<K> {
	try {
		await OrderingFacade.blockTicketByPos(ticketId);
		return await closingAction();
	}
	finally {
		await OrderingFacade.unblockTicketByPos(ticketId, false);
	}
}